import React from 'react';
import classnames from 'classnames';
import { FlightInformation, RountTrip } from '../../../components';
import { vehicleOptionsDictionary } from '../../../dictionaries';
import { DateHelper, LodashHelper, renderRecordValue } from '../../../utils';
import { STATUSES_STYLING } from '../../../constants/styles/statuses';
import { DRIVER_NOT_ASSIGNED, rescheduleMessage } from '../../../constants/constants';
import { RIDE_STATUSES } from '../../../constants/constants';
import { getRiderActualHeightForBariaticVehicleType, getRiderActualWeightForBariaticVehicleType, getRideStatusLabel } from '../../../utils/helpers';
import styles from './index.module.css';
import { Popover, Tag } from 'antd';
import { OverNight } from '../../../components/common/OverNight/OverNight';
import classNames from 'classnames';
import { RescheduleRideIcon } from '../../../components/common/RescheduleRideIcon/RescheduleRideIcon';
import { AdditionalSeat } from '../../../components/common/AdditionalSeat/AdditionalSeat';
import { UberHealthTag } from '../../../components/common/UberHealthTag/UberHealthTag';
import { RideDriverPopover } from '../../../components/common/RideDriverPopover/RideDriverPopover';

export const renderColumns = () => [
  {
    title: "Ride ID",
    dataIndex: "seqId",
    key: "seqId",
    render: (text, record) => (
      <div
        className={classnames({
          [styles.draftIdCellValue]: true,
          [styles.cellValue]: true,
        })}
      >
        <span style={{ display: 'inline-flex', alignItems: 'center' }}>
          {record?.flightInfo ? (
            <Popover
              content={<FlightInformation flightInfo={record?.flightInfo} />}
              placement="topLeft"
              getPopupContainer={() => document.querySelector(".ant-table")}
            >
              <span style={{ color: "blue", textDecorationLine: "underline" }}>
                {renderRecordValue(text)}
              </span>
            </Popover>
          ) : (
            renderRecordValue(text)
          )}
          <RideDriverPopover record={record} />
        </span>

        {/* {record?.uberInfo?.driverInfo?.phone && (
          <div className={styles.uberListTripLine}>
            {record.uberInfo.driverInfo.phone}
          </div>
        )} */}

        <br />
        <div className={styles.displayIcons}>
          <OverNight record={record} />
          <AdditionalSeat record={record} />
        </div>

        <div className={styles.dflex}>
          <RountTrip record={record} />
        </div>
        {(record?.status === RIDE_STATUSES.RESCHEDULED && record?.rescheduledFrom) && (
          <RescheduleRideIcon />
        )}
      </div>

      //  <div
      //    className={classnames({
      //     [styles.draftIdCellValue]: true,
      //      [styles.cellValue]: true,
      //   })}>
      //    {renderRecordValue(text)}
      //    <br />
      //    <RountTrip record={record} />
      //  </div> -->
    ),
    width: 150,
  },
  {
    title: "Rider Name",
    dataIndex: "rider",
    key: "rider",
    width: 180,
    render: (text) => (
      <div
        className={classnames({
          [styles.riderCellValue]: true,
          [styles.cellValue]: true,
        })}
      >
        {renderRecordValue(text)}
      </div>
    ),
  },
  {
    title: "Vehicle Type",
    dataIndex: "vehicleType",
    key: "vehicleType",
    width: 280,
    render: (text, record) => (
      <>
        <div
          className={classnames({
            [styles.vehicleCellValue]: true,
            [styles.cellValue]: true,
          })}
        >
          {renderRecordValue(vehicleOptionsDictionary[text])}
          {text === 'uberAmbulatoryRide' && <UberHealthTag />}
        </div>
        <div
          className={classnames({
            [styles.vehicleCellValue]: true,
            [styles.cellValue]: true,
            [styles.actualWeight]: true,
          })}
        >
          <div> {getRiderActualWeightForBariaticVehicleType(text, record)}</div>
          <div> {getRiderActualHeightForBariaticVehicleType(text, record)}</div>
        </div>
      </>
    ),
  },
  {
    title: "Ride Details",
    dataIndex: "rideOptions",
    key: "rideOptions",
    width: 200,
    render: (values) => (
      <div
        className={classnames({
          [styles.rideOptionsCellValue]: true,
          [styles.cellValue]: true,
        })}
      >
        <span className={classnames({ [styles.cellValue]: true })}>
          {renderRecordValue(values && LodashHelper.pluck(values, "value"))}
        </span>
      </div>
    ),
  },
  {
    title: "Pickup Date",
    dataIndex: "pickUpDate",
    key: "pickUpDate",
    width: 250,
    render: (value) => (
      <div
        className={classnames({
          [styles.pickUpDateCellValue]: true,
          [styles.cellValue]: true,
        })}
      >
        {renderRecordValue(value)}
      </div>
    ),
  },

  {
    title: "Driver Name",
    dataIndex: "driver",
    key: "driver",
    width: 150,
    render: (text, record) => (
      <div
        className={classnames({
          [styles.driverCellValue]: true,
          [styles.cellValue]: true,
          [styles.driverNotAssigned]:
            RIDE_STATUSES.ACCEPTED === record.status && !text,
        })}
      >
        {RIDE_STATUSES.ACCEPTED === record.status && !text
          ? renderRecordValue(DRIVER_NOT_ASSIGNED)
          : renderRecordValue(text)}
      </div>
    ),
  },
  {
    title: "Ride Status",
    dataIndex: "readableStatus",
    key: "readableStatus",
    width: 160,
    render: (text, record) => (
      <div
        className={classnames({

          [STATUSES_STYLING[text]]: true,
        })}
      >


        {text.toLowerCase() === RIDE_STATUSES.RESCHEDULED.toLowerCase() ? (

          <Popover
            content={`This ride has been rescheduled. Accept before ${record?.updatedAt && DateHelper.addHoursAndConvertToTimezone(record?.updatedAt, 4, record?.timezone)} to avoid expiration`}
            placement='topLeft'
            overlayClassName={classNames({
              [styles.overlay]: true,

            })}
            getPopupContainer={(trigger) => trigger}>
            <div>

              {renderRecordValue(text)}
            </div>
          </Popover>



        ) : (
          renderRecordValue(getRideStatusLabel(text, RIDE_STATUSES.CANCELED))
        )}



      </div>
    ),
  },
];
